import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { returnsApi } from '../../api/returns';

export function RTODashboardPage() {
  const [rtos, setRtos] = useState<unknown[]>([]);

  useEffect(() => {
    void returnsApi.listRTO().then(setRtos);
  }, []);

  async function processRTO() {
    await returnsApi.processRTO({ shipment_id: `SHP-${Date.now()}`, order_id: `ORD-${Date.now()}` });
    setRtos(await returnsApi.listRTO());
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/returns" className="text-sm text-slate-600 hover:underline">← Returns hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">RTO dashboard</h1>
      <button type="button" onClick={() => void processRTO()}
        className="mt-4 rounded bg-slate-900 px-4 py-2 text-sm text-white">Process RTO</button>
      <p className="mt-4 text-sm text-slate-600">{rtos.length} RTO records</p>
    </div>
  );
}
